import { UserEngagementData } from "../domain/UserEngagementData";
import { UserEngagementRepository } from "../domain/UserEngagementRepository";
import { client } from "../../../api/client";

export class APIUserEngagementRepository implements UserEngagementRepository {
  async get_data(): Promise<UserEngagementData> {
    return await client
      .get(`get_engagement_data/`)
      .then((response) => response.data);
  }
}
